function StoreCampaignsController($scope, PermissionService, $stateParams, $state, StoresService, ErrorService) {
    var self = this;

    self.initialise = function() {
        self.userContext = PermissionService.userContext;

        // Check that the current store in the context is subscribed to the Yumbi Campaigns subscription
        checkStoreSubscribedToCampaigns();
    };

    /**
     * Check that the current store in the context is subscribed to the Yumbi Campaigns subscription
     */
    var checkStoreSubscribedToCampaigns = function () {
        // Navigates to the store subscription page passing in the Yumbi Campaigns subscription Id
        var navigateToStoreSubscription = function () {
            StoresService.getSubscriptionByName(Dashboard.Subscriptions.YumbiCampaigns).then(
                function (results) {
                    $state.go('app.storesubscription', {id: results.Id, storeId: self.userContext.StoreId });
                },
                function error (results) {
                    ErrorService.showError("An unexpected error has occurred", results);
                }
            );
        };

        StoresService.checkStoreSubscription(self.userContext.StoreId, Dashboard.Subscriptions.YumbiCampaigns).then(
            function (result) {
                if (!result) {
                    navigateToStoreSubscription();
                }
            }
        );
    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('storeCampaigns',
        {
            templateUrl: 'components/store/campaigns/campaigns.42ac1333.html',
            bindings: {},
            controller: ['$scope', 'PermissionService', '$stateParams', '$state', 'StoresService', 'ErrorService', StoreCampaignsController]
        });